import {createFileRoute} from '@tanstack/react-router';

import {AccountPage} from '@/modules/auth/pages/AccountPage';

export const Route = createFileRoute('/_authenticated/account/profile')({
  component: AccountPage,
});
